"use client"

import { useCookieConsent } from "./consent-context"

// Permanent footer entry that re-opens the consent preferences modal.
// Lives in the existing footer's bottom strip so users can always change
// their mind without hunting for a hidden control.
export default function CookieSettingsLink({
  className,
}: {
  className?: string
}) {
  const { openPreferences } = useCookieConsent()
  return (
    <button
      type="button"
      onClick={openPreferences}
      className={
        className ??
        "text-sm text-white/50 transition-colors hover:text-white"
      }
    >
      Cookie settings
    </button>
  )
}
